import { render, staticRenderFns } from "./commercial-broad.vue?vue&type=template&id=3d5ef88d"
import script from "./commercial-broad.vue?vue&type=script&lang=js"
export * from "./commercial-broad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports